let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iQYZ7")).then(() => parcelRequire('boEdP'));